(() => {
  if (window.CSFeaturedCollectionLoaded) return;
  window.CSFeaturedCollectionLoaded = true;

  function setFulfillmentFields(form, madeToOrder, hasVariant) {
    const property = form.querySelector('[data-grid-mto-property]');
    const flag = form.querySelector('[data-grid-mto-flag]');
    const priority = form.querySelector('[data-grid-mto-priority]');
    const fulfillmentType = form.querySelector('[data-grid-fulfillment-type]');

    [property, flag, priority].filter(Boolean).forEach((field) => {
      field.disabled = !madeToOrder || !hasVariant;
    });

    if (property) property.value = madeToOrder && hasVariant ? 'MADE TO ORDER' : '';
    if (flag) flag.value = madeToOrder && hasVariant ? 'YES' : '';
    if (priority) priority.value = madeToOrder && hasVariant ? 'AFTER PRE-MADE INVENTORY' : '';

    if (fulfillmentType) {
      fulfillmentType.disabled = !hasVariant;
      fulfillmentType.value = hasVariant ? (madeToOrder ? 'MADE TO ORDER' : 'PREMADE') : '';
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-grid-size-button]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();

    const form = button.closest('.cs-grid-quick-add-form');
    if (!form) return;

    const variantInput = form.querySelector('[name="id"]');
    const submit = form.querySelector('[data-grid-add-button]');
    const label = submit?.querySelector('[data-grid-add-label]');
    const notice = form.querySelector('[data-grid-mto-notice]');
    const variantId = button.dataset.variantId;
    const madeToOrder = button.dataset.madeToOrder === 'true';

    form.querySelectorAll('[data-grid-size-button]').forEach((item) => {
      item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
    });

    if (variantInput) variantInput.value = variantId || '';
    setFulfillmentFields(form, madeToOrder, Boolean(variantId));

    if (notice) notice.hidden = !madeToOrder || !variantId;
    if (submit) {
      submit.disabled = !variantId;
      submit.toggleAttribute('aria-disabled', !variantId);
      submit.dataset.gridButtonState = variantId ? 'ready' : 'waiting';
      submit.classList.toggle('is-made-to-order', madeToOrder && Boolean(variantId));
    }

    if (label) {
      label.textContent = variantId
        ? (madeToOrder ? submit.dataset.mtoLabel : submit.dataset.addLabel)
        : submit.dataset.selectLabel;
    }

    const status = form.querySelector('[data-grid-quick-add-status]');
    if (status) status.textContent = '';
  });
})();
